import { VAnmeldelseUtkast } from "../valideringstyper/domenetyper/anmeldelseUtkast";

const valideringsmeldinger: VAnmeldelseUtkast = {
  anmeldelseType: {
    en: {
      av: "Kan ikkje sende inn ei melding av denne typen. Vennligst opprett ei melding som ein av følgande typar: {{messageParams.values, anmeldelse_type_list_formatter}}",
    },
  },
  samtykkeInformasjon: {
    ikke: {
      null: "Du må svara om du samtykkjer til innhenting av opplysningar",
    },
    samtykkeInnhentingAvOpplysninger: {
      ikke: {
        null: "Du må svara om du samtykkjer til innhenting av opplysningar",
      },
    },
  },
  fornaermet: {
    konfliktraadinformasjon: {
      ikke: {
        null: "Du må svare på om fornærma er villig til å behandle saka i konfliktråd",
      },
      fornaermetVilligTilKonfliktraad: {
        ikke: {
          null: "Du må svare på om fornærma er villig til å behandle saka i konfliktråd",
        },
      },
    },
    person: {
      ikke: {
        null: "Du må fylla ut fornærma person",
      },
      anmeldersRelasjonTilFornaermetPerson: {
        ikke: {
          null: "Du må oppgi meldar sin relasjon til den fornærma",
        },
      },
      anmeldersRelasjonTilFornaermetPersonAnnenBeskrivelse: {
        ikke: {
          null: "Du må beskrive relasjonen til den fornærma",
          blank: "Kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde: "For lang skildring av relasjonen til den fornærma",
        },
      },
      kontaktopplysninger: {
        ikke: {
          null: "Du må oppgi kontaktopplysningar til den fornærma",
        },
        epost: {
          ikke: {
            null: "Du må oppgi ei e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi ei gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi eit gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi eit telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      navn: {
        ikke: {
          null: "Du må oppgi eit namn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikkje eit gyldig fødsels- eller d-nummer",
        },
      },
      beskrivelse: {
        maks: {
          lengde: "For lang skildring av den fornærma",
        },
        ikke: {
          blank: "Kan ikkje bestå av berre blanke teikn",
        },
      },
    },
    virksomhet: {
      anmeldersRelasjonTilFornaermetVirksomhet: {
        ikke: {
          null: "Du må oppgi meldar sin relasjon til verksemda",
        },
      },
      anmeldersRelasjonTilFornaermetVirksomhetAnnenBeskrivelse: {
        maks: {
          lengde:
            "Skildringa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
        },
        ikke: {
          null: "Du må oppgi annan relasjon til verksemda",
          blank: "Relasjonen kan ikkje bestå av berre blanke teikn",
        },
      },
      ikke: {
        null: "Du må velje kven som er fornærma",
      },
      maaFylleUtVirksomhet: "Du må velje kven som er fornærma",
      vekterSelskap: {
        maaFylleUtVirksomhet:
          "Du må velje kva for eit vektarselskap du jobbar for",
      },
      virksomhetensReferanse: {
        ikke: {
          blank:
            "Referansen for verksemda kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "Referansen for verksemda er for lang, maks lengd er {{messageParams.maxLength}} teikn",
        },
        begrensetTegnsett:
          "Referansen for verksemda har ugyldig teikn, {{messageParams.ugyldigeTegn}} er ikkje tillaten",
      },
      samtykkeVirksomhetKanSeAnmeldelsen: {
        ikke: {
          null: "Du må oppgi om vil sende ein kopi av meldinga til verksemda",
        },
      },
    },
    type: {
      ikke: {
        null: "Du må oppgi kven du melder på vegner av",
      },
      en: {
        av: "Ugyldig val av type fornærma",
      },
    },
  },
  vedlegg: {
    metadata: {
      root: {
        maks: {
          size: "Du kan ikkje laste opp fleire enn {{messageParams.maxSize}} vedlegg",
        },
        korruptFil:
          "Vi kan ikkje behandle fila du har lasta opp. Det kan hjelpe å eksportere fila i eit anna format og prøve igjen",
        passordbeskyttetFil:
          "Fila er passordbeskytta, vennlegast fjern passordet frå fila og prøv igjen",
        forMangeSider:
          "Fila har meir enn 15000 sider, ver vennleg og reduser talet på sider og prøv igjen",
        duplikat: {
          fil: "Fil med same namn eller innhald er allereie lasta opp under $t({{propertyPath}}_lokasjon.{{messageParams.kontekst}}). Endra filnamnet eller vel ein annan",
          fil_lokasjon: {
            ANMELDELSE: "vedlegg-steg",
            ERSTATNINGSKRAV_VEDLEGG: "erstatningskrav",
            ERSTATNINGSKRAV_FULLMAKT: "fullmakt",
          },
        },
      },
      opplastet: {
        true: "Vedlegget er ikkje lasta opp, viss feilen held fram, prøv å laste opp vedlegget på nytt",
      },
      checksum: {
        feilVedOpplasting:
          "Det skjedde ein feil ved opplasting av fila, ver vennleg og prøv igjen",
      },
      filendelse: {
        gyldig: {
          mimetype:
            "Fila kan ikkje lastast opp fordi filtypen ikkje stemmer med innhaldet i fila",
          filtype:
            "Vi støttar ikkje denne filtypen, filtypar vi støttar er {{AKSEPTERTE_FILER_STRING}}",
        },
      },
      malwareScanStatus: {
        malwareScanIkkeOk:
          "Dette vedlegget vart stoppa i virusscanning og må fjernast for at du skal kunne sende inn meldinga",
      },
      stoerrelse: {
        ikke: {
          tom: "Fila manglar innhald, ver vennleg og vel ei fil som ikkje er tom",
        },
        filstoerrelse: {
          maks: "Filen er for stor, ho kan ikkje vere større enn {{messageParams.maksFilstoerrelseString}}",
          totalt:
            "Samla størrelse for vedlegga kan ikkje vere meir enn {{messageParams.maksFilstoerrelseString}}",
        },
      },
      filnavn: {
        gyldig: {
          verdi: "Filnamnet er ikkje gyldig. Unngå å bruke spesialteikn",
        },
        maks: {
          lengde:
            "Filnamnet er for langt, maks lengde er {{messageParams.maxLength}} teikn",
        },
        ikke: {
          blank: "Filnamnet kan ikkje bestå av berre blanke teikn",
        },
      },
      opplastetBytes: {
        feilVedOpplasting:
          "Det skjedde en feil ved opplasting av filen, vennligst prøv igjen",
      },
    },
    beskrivelse: {
      maks: {
        lengde:
          "Skildringa av vedlegget er for lang, maks lengde er {{messageParams.maxLength}} teikn",
      },
      ikke: {
        blank: "Skildringa kan ikkje bestå av berre blanke teikn",
      },
    },
  },
  hendelsestidspunkt: {
    fra: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "Frå-dato kan ikkje vere seinare enn datoen og klokkeslettet i dag",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              til: "Fra-dato kan ikkje vere meir enn 50 år tilbake",
            },
          },
        },
      },
      ikke: {
        null: "Du må oppgi dato og tid for når hendinga starta",
      },
    },
    til: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "Til-dato kan ikkje vere seinare enn datoen og klokkelsettet i dag",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              fra: "Til-dato kan ikkje vere tidlegare enn frå-dato",
            },
          },
        },
      },
    },
  },
  experimentalFields: {
    experimentalGjerningsaktorInformasjon: {
      ikke: {
        null: "Du må svara på om du kan hjelpa oss med å identifisera anteken gjerningsperson",
      },
      gjerningsaktorErKjent: {
        ikke: {
          null: "Du må svara på om du kan hjelpa oss med å identifisera anteken gjerningsperson",
        },
      },
      gjerningsaktorer: {
        maks: {
          size: "Du kan ikkje leggja til meir enn éi verksemd",
        },
        ikke: {
          tom: "Du må leggja til kven du meiner har gjort det",
        },
        begrunnelseForInvolvering: {
          ikke: {
            blank: "Grunngivinga kan ikkje bestå av berre tomme teikn",
            null: "Du må grunngi kvifor du meiner gjerningspersonen er involvert",
          },
          maks: {
            lengde:
              "For lang grunngiving, maks lengd er {{messageParams.maxLength}} teikn",
          },
        },
        gjerningsvirksomhet: {
          ikke: {
            null: "Du må leggja til ei verksemd",
          },
          orgnummer: {
            ikke: {
              null: "Du må oppgi organisasjonsnummer",
            },
          },
          navn: {
            ikke: {
              null: "Du må oppgi namn på verksemda",
            },
          },
          manuellVirksomhet: {
            navn: {
              ikke: {
                null: "Du må oppgi namn på verksemda",
                blank: "Verksemdsnamn kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "Verksemdsnamnet er for langt, maks lengd er {{messageParams.maxLength}} teikn",
              },
            },
            informasjonselementer: {
              verdi: {
                mangler: {
                  verdiForInformasjonselement:
                    "Du må fylle inn verdien for dette feltet",
                  verdiForInformasjonselement_EPOST:
                    "Du må oppgi ei e-postadresse",
                  verdiForInformasjonselement_TELEFON:
                    "Du må oppgi eit telefonnummer",
                  verdiForInformasjonselement_ADRESSE: "Du må oppgi ei adresse",
                  verdiForInformasjonselement_NETTSTED:
                    "Du må oppgi ein nettstad",
                  verdiForInformasjonselement_ORGNR:
                    "Du må oppgi eit organisasjonsnummer",
                  verdiForInformasjonselement_ANNET: "Du må oppgi ein verdi",
                },
                gyldig: {
                  epost: "Du må oppgi ei gyldig e-postadresse",
                  telefonnummer: "Du må oppgi eit gyldig telefonnummer",
                  nettstedsadresse: "Du må oppgi ei gyldig nettstadsadresse",
                },
                maks: {
                  lengde:
                    "Verdien er for lang, maks lengd er {{messageParams.maxLength}} teikn",
                },
                ikke: {
                  null: "Du må fylle inn verdien for dette feltet",
                  blank: "Feltet kan ikkje bestå av berre blanke teikn",
                },
              },
            },
          },
        },
        gjerningsperson: {
          root: {
            minstEnInfoGjerningsperson:
              "Du må leggja til minst éin type opplysning",
          },
          personopplysninger: {
            minstEnInfoGjerningsperson:
              "Du må leggja til minst éi personopplysning",
          },
          ikke: {
            null: "Du må leggja til ein gjerningsperson",
          },
          foedselsEllerDnummer: {
            ikke: {
              null: "Du må oppgi fødsels- eller d-nummer",
            },
            gyldig: {
              foedselsEllerDnummer:
                "Dette er ikkje eit gyldig fødsels- eller d-nummer",
            },
          },
          foedselsdato: {
            dato: {
              mindre: {
                eller: {
                  lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
                  lik_comparison: {
                    now: "Fødselsdato kan ikkje vere fram i tid",
                  },
                },
              },
            },
          },
          personnavn: {
            ikke: {
              null: "Du må oppgi eit namn",
            },
            etternavn: {
              ikke: {
                null: "Du må oppgi etternamn",
                blank: "Kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            fornavn: {
              ikke: {
                null: "Du må oppgi fornamn",
                blank: "Kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            mellomnavn: {
              ikke: {
                null: "Du må oppgi mellomnamn",
                blank: "Kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          ekstraKontaktopplysninger: {
            typeKontaktopplysning: {
              ikke: {
                null: "Du må oppgi typa kontaktopplysning",
              },
            },
            verdi: {
              gyldig: {
                telefonnummer: "Du må oppgi eit gyldig telefonnummer",
                epost: "Du må oppgi ein gyldig e-postadresse",
              },
              ikke: {
                null: "Du må oppgi ei kontaktopplysning",
                blank: "Kontaktopplysningen kan ikkje bestå av kun tomme teikn",
              },
              maks: {
                lengde:
                  "Kontaktopplysninga er for lang, maks lengd er {{messageParams.maxLength}} teikn",
              },
              mangler: {
                verdiForKontaktopplysning: "Du må oppgi ei kontaktopplysning",
                verdiForKontaktopplysning_TELEFONNUMMER:
                  "Du må oppgi eit telefonnummer",
                verdiForKontaktopplysning_EPOST: "Du må oppgi ei e-postadresse",
                verdiForKontaktopplysning_BRUKERNAVN:
                  "Du må oppgi eit brukarnamn",
                verdiForKontaktopplysning_ADRESSE: "Du må oppgi ei adresse",
                verdiForKontaktopplysning_ANNET: "Du må oppgi ein verdi",
              },
            },
            context: {
              ikke: {
                null: "Du må oppgi kontekst for kontaktopplysninga",
                blank: "Konteksten kan ikkje bestå av berre tomme teikn",
              },
              maks: {
                lengde:
                  "Konteksten er for lang, maks lengd er {{messageParams.maxLength}} teikn",
              },
            },
          },
          personBeskrivelse: {
            ikke: {
              blank: "Skildringa kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For lang skildring av gjerningspersonen, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          gjerningspersonErMyndig: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              foedselsdato: "Alder må samsvare med fødselsdato",
              foedselsnummer: "Alder må samsvare med fødselsnummer",
            },
            ikke: {
              null: "Du må oppgi alder til gjerningspersonen",
            },
          },
          identifiseringsinformasjon: {
            beskrivelse: {
              ikke: {
                blank: "Skildringa kan ikkje bestå av berre tomme teikn",
                null: "Du må beskrive korleis du identifiserte gjerningspersonen",
              },
              maks: {
                lengde:
                  "For lang skildring av framvist id, maks lengde er {{messageParams.maxLength}} teikn ",
              },
            },
            ikke: {
              null: "Du må velje ein metode for identifisering",
            },
            metode: {
              ikke: {
                null: "Du må velje ein metode for identifisering",
              },
            },
          },
          verge: {
            kontaktopplysninger: {
              epost: {
                ikke: {
                  null: "Du må oppgi ei e-postadresse",
                },
                gyldig: {
                  epost: "Du må oppgi ei gyldig e-postadresse",
                },
                maks: {
                  lengde:
                    "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              telefonnummer: {
                gyldig: {
                  telefonnummer: "Du må oppgi eit gyldig telefonnummer",
                },
                ikke: {
                  null: "Du må oppgi eit telefonnummer",
                },
                maks: {
                  lengde:
                    "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            personnavn: {
              ikke: {
                null: "Du må oppgi eit namn",
              },
              etternavn: {
                ikke: {
                  null: "Du må oppgi etternamn",
                  blank: "Etternamn kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              fornavn: {
                ikke: {
                  null: "Du må oppgi fornamn",
                  blank: "Fornamn kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "Du må oppgi mellomnamn",
                  blank: "Mellomnamn kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            vergeErKontaktet: {
              ikke: {
                null: "Du må svare på om du har kontakta verja",
              },
            },
            vergeTilStede: {
              ikke: {
                null: "Du må svare på om verja kom til staden",
              },
            },
          },
          oppgitteOpplysninger: {
            personnavn: {
              ikke: {
                null: "Du må oppgi eit namn",
              },
              etternavn: {
                ikke: {
                  null: "Du må oppgi etternamn",
                  blank: "Kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              fornavn: {
                ikke: {
                  null: "Du må oppgi fornamn",
                  blank: "Kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "Du må oppgi mellomnamn",
                  blank: "Kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            virksomhetNavn: {
              ikke: {
                blank: "Oppgitt verksemd kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt namn for oppgitt verksemd, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            andreOpplysninger: {
              ikke: {
                blank:
                  "Andre opplysningar kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskriving av andre opplysningar, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
        },
      },
    },
  },
  gjerningspersonInformasjon: {
    gjerningspersoner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Fødselsdato kan ikkje vere fram i tid",
              },
            },
          },
        },
      },
      gjerningspersonErMyndig: {
        lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
        lik_comparison: {
          foedselsdato: "Alder må samsvare med fødselsdato",
          foedselsnummer: "Alder må samsvare med fødselsnummer",
        },
        ikke: {
          null: "Du må oppgi alder til gjerningspersonen",
        },
      },
      begrunnelseForInvolvering: {
        ikke: {
          blank: "Grunngivinga kan ikkje berre bestå av tomme teikn",
          null: "Du må grunngje kvifor du meiner gjerningspersonen er involvert",
        },
        maks: {
          lengde:
            "For lang grunngiving, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang skildring av gjerningspersonen, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
      identifiseringsinformasjon: {
        beskrivelse: {
          ikke: {
            blank: "Skildringa kan ikkje bestå av berre tomme teikn",
            null: "Du må beskrive korleis du identifiserte gjerningspersonen",
          },
          maks: {
            lengde:
              "For lang skildring av framvist id, maks lengde er {{messageParams.maxLength}} teikn ",
          },
        },
        ikke: {
          null: "Du må velje ein metode for identifisering",
        },
        metode: {
          ikke: {
            null: "Du må velje ein metode for identifisering",
          },
        },
      },
      root: {
        minstEnInfoGjerningsperson:
          "Du må fylle ut minst eitt av felta om den du antar er gjerningsperson",
      },
      ikke: {
        tom: "Du må legge til ein gjerningsperson",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "Du må oppgi ei e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi ei gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi eit gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi eit telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      ekstraKontaktopplysninger: {
        typeKontaktopplysning: {
          ikke: {
            null: "Du må oppgi typa kontaktopplysning",
          },
        },
        verdi: {
          gyldig: {
            telefonnummer: "Du må oppgi eit gyldig telefonnummer",
            epost: "Du må oppgi ein gyldig e-postadresse",
          },
          ikke: {
            null: "Du må oppgi ei kontaktopplysning",
            blank: "Kontaktopplysningen kan ikkje bestå av kun tomme teikn",
          },
          maks: {
            lengde:
              "Kontaktopplysninga er for lang, maks lengd er {{messageParams.maxLength}} teikn",
          },
        },
        context: {
          ikke: {
            null: "Du må oppgi kontekst for kontaktopplysninga",
            blank: "Konteksten kan ikkje bestå av berre tomme teikn",
          },
          maks: {
            lengde:
              "Konteksten er for lang, maks lengd er {{messageParams.maxLength}} teikn",
          },
        },
      },
      verge: {
        kontaktopplysninger: {
          epost: {
            ikke: {
              null: "Du må oppgi ei e-postadresse",
            },
            gyldig: {
              epost: "Du må oppgi ei gyldig e-postadresse",
            },
            maks: {
              lengde:
                "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          telefonnummer: {
            gyldig: {
              telefonnummer: "Du må oppgi eit gyldig telefonnummer",
            },
            ikke: {
              null: "Du må oppgi eit telefonnummer",
            },
            maks: {
              lengde:
                "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
        },
        personnavn: {
          ikke: {
            null: "Du må oppgi eit namn",
          },
          etternavn: {
            ikke: {
              null: "Du må oppgi etternamn",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          fornavn: {
            ikke: {
              null: "Du må oppgi fornamn",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          mellomnavn: {
            ikke: {
              null: "Du må oppgi mellomnamn",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
        },
        vergeErKontaktet: {
          ikke: {
            null: "Du må svare på om du har kontakta verja",
          },
        },
        vergeTilStede: {
          ikke: {
            null: "Du må svare på om verja kom til staden",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "Du må oppgi eit namn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikkje eit gyldig fødsels- eller d-nummer",
        },
      },
      harVergesKontaktinformasjon: {
        ikke: {
          null: "Du må svare på om du har kontaktinformasjonen til verja",
        },
      },
    },
    gjerningspersonErKjent: {
      ikke: {
        null: "Du må svare på om du kan hjelpe oss med å identifisere antatt gjerningsperson",
      },
    },
  },
  vitneInformasjon: {
    andreVitner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Fødselsdato kan ikkje vere fram i tid",
              },
            },
          },
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang skildring av vitne, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
      ikke: {
        tom: "Det må vere minst eitt vitne",
      },
      root: {
        minstEnInfoVitne:
          "Du må fylle ut minst eitt av felta om den som er vitne",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "Du må oppgi ei e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi ei gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi eit gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi eit telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "Du må oppgi eit namn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt etternamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt fornamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnamn",
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For langt mellomnamn, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikkje eit gyldig fødsels- eller d-nummer",
        },
      },
    },
    andreErVitne: {
      ikke: {
        null: "Du må svare på om du har kontaktinformasjonen til andre vitne",
      },
    },
    anmelderErVitne: {
      ikke: {
        null: "Du må svare på om du sjølv var vitne til hendinga",
      },
    },
  },
  hendelsesbeskrivelse: {
    handlinger: {
      tyveri: {
        gjenstander: {
          harForsikring: {
            ikke: {
              null: "Du må svara på om du har forsikring",
            },
          },
          forsikring: {
            ikke: {
              null: "Du må fylla ut forsikringsinformasjon",
            },
            forsikringsselskap: {
              maaFylleUtVirksomhet:
                "Du må oppgi kva for ei verksemd som har forsikra gjenstanden",
            },
            polisenummer: {
              ikke: {
                null: "Du må oppgi polisenummer",
                blank: "Du må oppgi polisenummer",
              },
              maks: {
                lengde:
                  "Polisenummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          handelsvarer: {
            varer: {
              antall: {
                stoerre: {
                  enn: "Antal må vere større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi antal",
                },
              },
              pris: {
                ikke: {
                  null: "Du må angi pris på gjenstanden",
                },
                stoerre: {
                  eller: {
                    lik: "Prisen må vere større enn eller lik {{messageParams.value}}",
                  },
                },
              },
              navn: {
                ikke: {
                  null: "Du må angi gjenstand",
                  blank: "Gjenstand kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde: "Gjenstandnamnet er for langt",
                },
              },
              ikke: {
                tom: "Du må legge til ein gjenstand",
                null: "Du må legge til ein gjenstand",
              },
            },
          },
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "Årsmodellen må vere større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi årsmodellen til køyretøyet",
                },
              },
              farge: {
                ikke: {
                  blank: "Fargen kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "Skildringa av fargen til køyretøyet er for lang, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              merke: {
                ikke: {
                  null: "Du må oppgi merket til køyretøyet",
                  blank: "Merke kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "Merket på køyretøyet er for langt, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              modell: {
                ikke: {
                  blank: "Modell kan ikkje bestå av berre blanke teikn",
                  null: "Du må oppgi modellen til køyretøyet",
                },
                maks: {
                  lengde:
                    "Modellnamnet på køyretøyet er for langt, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "Du må oppgi type køyretøy",
                },
              },
              understellsnummer: {
                ikke: {
                  blank:
                    "Understellsnummer kan ikkje bestå av berre blanke teikn",
                  null: "Du må oppgi understellsnummer",
                },
                maks: {
                  lengde:
                    "For langt understellsnummer, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank:
                    "Registreringsland kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank:
                    "Registreringsland kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "Du må oppgi registreringsnummer",
                  blank:
                    "Registreringsnummer kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "Du må søke etter registreringsnummeret",
                blank:
                  "Registreringsnummer kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "Skildringa kan ikkje bestå av berre blanke teikn",
              null: "Du må beskrive gjenstanden",
            },
            maks: {
              lengde:
                "For lang skildring av gjenstanden, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          ikke: {
            tom: "Du må legge til stolne gjenstandar",
            null: "Du må oppgi ein eller fleire gjenstandar",
          },
          kjennemerke: {
            antallSkilt: {
              ikke: {
                null: "Du må oppgi antal skilt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi kjennemerke",
              },
              min: {
                lengde:
                  "For kort kjennemerke, minimum lengde er {{messageParams.minLength}} teikn",
              },
              maks: {
                lengde:
                  "For langt kjennemerke, maksimum lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          gjenstandType: {
            ikke: {
              null: "Du må oppgi type gjenstand",
            },
          },
          mobiltelefon: {
            telefonnummer: {
              gyldig: {
                telefonnummer: "Du må oppgi eit gyldig telefonnummer",
              },
              ikke: {
                null: "Du må oppgi eit telefonnummer",
              },
              maks: {
                lengde:
                  "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merke",
                blank: "Merke kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt merkenamn, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modell",
                blank: "Modell kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt modellnamn, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            teleselskap: {
              ikke: {
                blank: "Teleselskap kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt teleselskap, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            imei: {
              ikke: {
                blank: "IMEI kan ikkje bestå av berre blanke teikn",
              },
              gyldig: {
                imei: "IMEI er ikkje gyldig",
              },
              maks: {
                lengde: "For langt IMEI nummer",
              },
              min: {
                lengde: "For kort IMEI nummer",
              },
              ugyldig: {
                moenster: "IMEI kan berre innehalde tal",
              },
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "Du må oppgi gyldig WIN",
            },
            lengde: {
              ikke: {
                null: "Du må oppgi lengda til fartøyet",
              },
              stoerre: {
                eller: {
                  lik: "Fartøyet må vere større enn eller lik {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "For langt fartøy",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket til fartøyet",
              },
              maks: {
                lengde: "Merket på fartøyet er for langt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi registreringsnummeret til fartøyet",
              },
              maks: {
                lengde: "Registreringsnummeret er for langt",
              },
            },
            skrogtype: {
              ikke: {
                null: "Du må oppgi skrogtype til fartøyet",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på fartøyet",
              },
            },
            modell: {
              maks: {
                lengde: "Modellnamnet på fartøyet er for langt",
              },
            },
          },
          sykkel: {
            merke: {
              ikke: {
                null: "Du må oppgi merke på sykkelen",
                blank: "Merke kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "Merket på sykkelen er for langt, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            modell: {
              ikke: {
                blank: "Modell kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "Modellnamnet på sykkelen er for langt, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på sykkelen",
              },
            },
            rammenummer: {
              ikke: {
                blank: "Rammenummer kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "Rammenummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          pris: {
            ikke: {
              null: "Du må oppgi pris på det som er stole",
            },
            lik: "Prisen må vere lik {{messageParams.value}}",
            stoerre: {
              eller: {
                lik: "Prisen må vere større eller lik {{messageParams.value}}",
              },
            },
          },
          elektronikk: {
            type: {
              ikke: {
                null: "Du må oppgi typen på elektronikken",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket på elektronikken",
                blank: "Merke kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Merket på elektronikken er for langt",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modellen på elektronikken",
                blank: "Modell kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Modellnamnet på elektronikken er for langt",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serienummer kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Serienummeret er for langt",
              },
            },
          },
          verktoy: {
            type: {
              ikke: {
                null: "Du må oppgi typen på verktøyet",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket på verktøyet",
                blank: "Merke kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Merket på verktøyet er for langt",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modellen på verktøyet",
                blank: "Modell kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Modellnamnet på verktøyet er for langt",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serienummer kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde: "Serienummeret er for langt",
              },
            },
          },
        },
      },
      skadeverk: {
        gjenstander: {
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "Årsmodellen må vere større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi årsmodellen til køyretøyet",
                },
              },
              farge: {
                ikke: {
                  blank: "Fargen kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "Skildringa av fargen til køyretøyet er for lang, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              merke: {
                ikke: {
                  null: "Du må oppgi merket til køyretøyet",
                  blank: "Merke kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "Merket på køyretøyet er for langt, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              modell: {
                ikke: {
                  blank: "Modell kan ikkje bestå av berre blanke teikn",
                  null: "Du må oppgi modellen til køyretøyet",
                },
                maks: {
                  lengde:
                    "Modellnamnet på køyretøyet er for langt, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "Du må oppgi type køyretøy",
                },
              },
              understellsnummer: {
                ikke: {
                  blank:
                    "Understellsnummer kan ikkje bestå av berre blanke teikn",
                  null: "Du må oppgi understellsnummer",
                },
                maks: {
                  lengde:
                    "For langt understellsnummer, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank:
                    "Registreringsland kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank:
                    "Registreringsland kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "Du må oppgi registreringsnummer",
                  blank:
                    "Registreringsnummer kan ikkje bestå av berre blanke teikn",
                },
                maks: {
                  lengde:
                    "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "Du må søke etter registreringsnummeret",
                blank:
                  "Registreringsnummer kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "Skildringa kan ikkje bestå av berre blanke teikn",
              null: "Du må beskrive skadeverket",
            },
            maks: {
              lengde:
                "For lang skildring av skadeverket, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
          ikke: {
            tom: "Du må legge til øydelagde gjenstandar",
            null: "Du må oppgi ein eller fleire gjenstandar",
          },
          gjenstandType: {
            ikke: {
              null: "Du må oppgi type gjenstand",
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "Du må oppgi gyldig WIN",
            },
            lengde: {
              ikke: {
                null: "Du må oppgi lengda til fartøyet",
              },
              stoerre: {
                eller: {
                  lik: "Fartøyet må vere større enn eller lik {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "For langt fartøy",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket til fartøyet",
              },
              maks: {
                lengde: "Merket på fartøyet er for langt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi registreringsnummeret til fartøyet",
              },
              maks: {
                lengde: "Registreringsnummeret er for langt",
              },
            },
            skrogtype: {
              ikke: {
                null: "Du må oppgi skrogtype til fartøyet",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på fartøyet",
              },
            },
            modell: {
              maks: {
                lengde: "",
              },
            },
          },
          formuestap: {
            ikke: {
              null: "Du må oppgi verdien på det som er øydelagt",
            },
            stoerre: {
              eller: {
                lik: "Verdien må vere større enn eller lik {{messageParams.value}}",
              },
            },
          },
        },
      },
      innbrudd: {
        beskrivelse: {
          ikke: {
            blank: "Skildringa kan ikkje bestå av berre blanke teikn",
            null: "Du må beskrive innbrotet",
          },
          maks: {
            lengde:
              "For lang skildring av hendinga, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      bedrageri: {
        bedragerimetode: {
          ikke: {
            null: "Du må oppgi ein bedragerimetode",
          },
          innledendeKontakt: {
            ikke: {
              null: "Du må svare på korleis du først kom i kontakt med svindlaren",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svare på korleis du først kom i kontakt med svindlaren",
                blank: "Skildringa kan ikkje bestå av kun blanke teikn",
              },
              maks: {
                lengde:
                  "For lang skildring, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          hvaSkjeddeBedrageriMetode: {
            ikke: {
              null: "Du må svare på kva som skjedde i bedrageriet",
            },
            moettSvindlerFysisk: {
              ikke: {
                null: "Du må svare på om du møtte svindlaren fysisk",
              },
            },
            harDuMottattLenke: {
              ikke: {
                null: "Du må svare på om du har fått ei lenkje",
              },
            },
            lenke: {
              ikke: {
                null: "Du må oppgi kva lenkje du har fått",
                blank: "Lenkja kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang lenkje, maks lengd er {{messageParams.maxLength}} teikn",
              },
            },
            harInstallertProgramEllerApp: {
              ikke: {
                null: "Du må svara på om du har installert eit program eller ein app",
              },
            },
            hvilketProgramEllerApp: {
              ikke: {
                null: "Du må oppgi eit program eller app",
                blank:
                  "Program eller app kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskriving av program eller app, maks lengd er {{messageParams.maxLength}} teikn",
              },
            },
            paaHvilkenEnhet: {
              ikke: {
                null: "Du må velja eit av alternativa",
              },
            },
          },
        },
        tilegnedeVerdier: {
          ikke: {
            null: "Du må svare på kva svindlarane har fått tak i",
            tom: "Du må svare på kva svindlarane har fått tak i",
          },
          type: {
            ikke: {
              null: "Du må svare på kva svindlarane har fått tak i",
            },
          },
          annenTilegnetVerdi: {
            ikke: {
              null: "Du må svare på kva anna verdi svindlarane har fått tak i",
            },
            beskrivelse: {
              ikke: {
                null: "Du må beskrive kva anna verdi svindlaren har fått tak i",
                blank:
                  "Du må beskrive kva anna verdi svindlaren har fått tak i",
              },
              maks: {
                lengde:
                  "For lang skildring, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
            sum: {
              ikke: {
                null: "Du må svare på verdi svindlaren har fått tak i",
              },
              stoerre: {
                eller: {
                  lik: "Summen må vere større eller lik {{messageParams.value}}",
                },
              },
            },
          },
          personinformasjon: {
            ikke: {
              null: "Du må legge til personinformasjon",
            },
            personinformasjonTypeListe: {
              ikke: {
                null: "Du må svare på kva svindlarane har fått tak i",
                tom: "Du må svare på kva svindlarane har fått tak i",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "Du må beskrive kva slags personinformasjon svindlarane har fått tak i",
                blank:
                  "Kva slags personinformasjon svindlarane har fått tak i kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av kva slags personinformasjon svindlarane har fått tak i, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          kode: {
            ikke: {
              null: "Du må leggja til kode",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svara på kva koden var til",
                blank:
                  "Kva koden var til kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskriving av kva koden var til, maks lengd er {{messageParams.maxLength}}  teikn",
              },
            },
          },
          passord: {
            ikke: {
              null: "Du må leggja til passord",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svara på kva passordet var til",
                blank:
                  "Kva passordet var til kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskriving av kva passordet var til, maks lengd er {{messageParams.maxLength}}  teikn",
              },
            },
          },
          fysiskId: {
            ikke: {
              null: "Du må leggja til fysisk ID",
            },
            fysiskIdTypeListe: {
              ikke: {
                null: "Du må svara på kva slags fysisk ID svindlarane har fått tak i",
                tom: "Du må svara på kva slags fysisk ID svindlarane har fått tak i",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "Du må beskrive kva slags fysisk ID svindlarane har fått tak i",
                blank:
                  "Kva slags fysisk ID svindlarane har fått tak i kan ikkje bestå av berre blanke teikn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av kva slags fysisk ID svindlarane har fått tak i, maks lengde er {{messageParams.maxLength}} teikn",
              },
            },
          },
          penger: {
            ikke: {
              null: "Du må legge til ein transaksjon",
              tom: "Du må legge til ein transaksjon",
            },
            fratattSum: {
              ikke: {
                null: "Du må svare på hvor mye du ble fratatt",
              },
              stoerre: {
                eller: {
                  lik: "Summen må vere større eller lik {{messageParams.value}}",
                },
              },
            },
            overforing: {
              ikke: {
                null: "Overføring kan ikkje vere null",
              },
              type: {
                ikke: {
                  null: "Du må svare på korleis du ble fratatt penger",
                },
              },
              kontooverforing: {
                ikke: {
                  null: "Du må legge til en kontooverføring",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi eit gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummer",
                  },
                  ikke: {
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                    null: "Du må svare på kva for ein konto pengane vart trekt frå",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                tilKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi eit gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummer",
                  },
                  ikke: {
                    null: "Du må svare på kva for ein konto pengane gikk til",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                    lik: {
                      verdi: "Frå konto og til konto kan ikkje vere like",
                    },
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på kva for ein bank pengane ble tatt fra",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
              },
              vippsoverforing: {
                ikke: {
                  null: "Du må legge til en Vipps-overføring",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi eit gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummer",
                  },
                  ikke: {
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                fraTelefonnummer: {
                  gyldig: {
                    telefonnummer: "Du må oppgi eit gyldig telefonnummer",
                  },
                  ikke: {
                    null: "Du må svare på hvilket telefonnummer pengane gikk fra",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                tilTelefonnummer: {
                  gyldig: {
                    telefonnummer: "Du må oppgi eit gyldig telefonnummer",
                  },
                  ikke: {
                    null: "Du må svare på hvilket telefonnummer pengane gikk til",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                    lik: {
                      verdi:
                        "Frå telefonnummer og til telefonnummer kan ikkje vere like",
                    },
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på kva for ein bank pengane ble tatt fra",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "Du må oppgi navn på mottakar",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
              },
              kryptooverforing: {
                ikke: {
                  null: "Du må legge til en krypto-overføring",
                },
                valuta: {
                  ikke: {
                    null: "Du må oppgi kva for ein kryptovaluta som vart overført",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                belop: {
                  ikke: {
                    null: "Du må oppgi beløp for krypto-overføringa",
                  },
                  stoerre: {
                    enn: "Beløpet må vere større enn {{messageParams.value}}",
                  },
                },
                fraAdresse: {
                  ikke: {
                    null: "Du må svare på kva for ein kryptovaluta-adresse pengane gikk fra",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                tilAdresse: {
                  ikke: {
                    null: "Du må svare på kva for ein kryptovaluta-adresse pengane gikk til",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                vekslingstjeneste: {
                  ikke: {
                    null: "Du må svare på kva for ein vekslingstjeneste som ble benyttet",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                transaksjonsId: {
                  ikke: {
                    null: "Du må oppgi transaksjons-ID",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
              },
              kortbetaling: {
                ikke: {
                  null: "Du må legge til en kortbetaling",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi eit gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummer",
                  },
                  ikke: {
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                kortnummer: {
                  gyldig: {
                    kortnummer: "Du må oppgi eit gyldig kortnummer",
                  },
                  ikke: {
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på kva for ein bank pengane ble tatt frå",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "Du må svara på kven som mottok pengane",
                    blank: "Teksten kan ikkje bestå av kun blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
              },
              annetoverforing: {
                ikke: {
                  null: "Du må legge til en annen type overføring",
                },
                beskrivelse: {
                  ikke: {
                    null: "Du må beskrive korleis pengane vart tatt og kvar de gikk",
                    blank: "Teksten kan ikkje bestå av berre blanke teikn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                  },
                },
              },
            },
            selvOverfort: {
              ikke: {
                null: "Du må svare på om du sjølv har overført pengane",
              },
              harDuSelvOverfortPengene: {
                ikke: {
                  null: "Du må svare på om du sjølv har overført pengane",
                },
              },
              overforingFormaal: {
                ikke: {
                  null: "Du må svare på kva formålet med overføringa var",
                },
              },
              annetOverforingFormaalBeskrivelse: {
                ikke: {
                  null: "Du må beskrive kva formålet med overføringa var",
                  blank: "Teksten kan ikkje bestå av kun blanke teikn",
                },
                maks: {
                  lengde:
                    "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
              erOverforingGodkjentMedPassordEtc: {
                ikke: {
                  null: "Du må svare på om du har godkjent overføringar ved å taste kode eller passord",
                },
              },
            },
            bankenStansetOverforing: {
              ikke: {
                null: "Du må svara på om banken har stansa overføringa",
              },
              harBankenStansetOverforingen: {
                ikke: {
                  null: "Du må svara på om banken har stansa overføringa",
                },
              },
              hvorMyeHarBankenStanset: {
                ikke: {
                  null: "Du må svara på kor mykje banken har stansa",
                },
                stoerre: {
                  enn: "Må vera større enn {{messageParams.value}}",
                },
                mindre: {
                  enn: "Må vera mindre enn summen på transaksjonen",
                },
              },
            },
            tilbakeforing: {
              ikke: {
                null: "Du må svare på om du har fått pengane tilbake",
              },
              type: {
                ikke: {
                  null: "Du må svare på om du har fått pengane tilbake",
                },
              },
              hvorMyeHarFornaermedeFaattTilbake: {
                ikke: {
                  null: "Du må svare på kor mykje du har fått tilbake",
                },
                stoerre: {
                  enn: "Må vera større enn {{messageParams.value}}",
                },
                mindre: {
                  enn: "Må vera mindre enn summen på transaksjonen",
                },
              },
              hvemHarFornaermedeFaattPengerFra: {
                ikke: {
                  null: "Du må oppgi kven du har fått pengane tilbake fra",
                  blank: "Teksten kan ikkje bestå av kun blanke teikn",
                },
                maks: {
                  lengde:
                    "For lang tekst, maks lengde er {{messageParams.maxLength}} teikn",
                },
              },
            },
          },
        },
        etterBedrageriet: {
          ikke: {
            null: "Du må forklare kva som skjedde etter bedrageriet",
          },
          vetBankenOmBedrageriet: {
            ikke: {
              null: "Du må svare på om banken veit om kva som har skjedd",
            },
          },
          erFornaermedesKortSperret: {
            ikke: {
              null: "Du må svare på om kortet ditt er sperret",
            },
          },
          erFornaermedesKontoSperret: {
            ikke: {
              null: "Du må svare på om kontoen din er sperret",
            },
          },
        },
      },
      datakrim: {
        hvaSkjedde: {
          ikke: {
            null: "Du må krysse av for minst éi beskriving",
          },
          datakrimHendelser: {
            ikke: {
              tom: "Du må krysse av for minst éi beskriving",
              null: "Du må krysse av for minst éi beskriving",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må beskrive kort kva som har skjedd",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For lang beskriving, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
        },
        dataPaAvveie: {
          ikke: {
            null: "Du må svare på om du trur at data er på avvegar",
          },
          svar: {
            ikke: {
              null: "Du må svare på om du trur at data er på avvegar",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må forklare kvifor du trur data er på avvegar",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For lang beskriving, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
        },
        andreMyndigheterVarslet: {
          ikke: {
            null: "Du må svare på om andre verksemder eller myndigheiter er varsla eller involverte",
          },
          svar: {
            ikke: {
              null: "Du må svare på om andre verksemder eller myndigheiter er varsla eller involverte",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må svare på kva for myndigheiter eller verksemder som er varsla eller involverte",
              blank: "Kan ikkje bestå av berre blanke teikn",
            },
            maks: {
              lengde:
                "For lang beskriving, maks lengde er {{messageParams.maxLength}} teikn",
            },
          },
        },
        tilleggsinformasjon: {
          ikke: {
            blank: "Kan ikkje bestå av berre blanke teikn",
          },
          maks: {
            lengde:
              "For lang tilleggsinformasjon, maks lengde er {{messageParams.maxLength}} teikn",
          },
        },
      },
      ikke: {
        tom: "Du må svare på kva som har skjedd",
      },
    },
    beskrivelse: {
      ikke: {
        blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        null: "Du må forklare korleis hendinga skjedde",
      },
      maks: {
        lengde:
          "For lang skildring av hendinga, maks lengde er {{messageParams.maxLength}} teikn",
      },
    },
  },
  erstatningskrav: {
    beskrivelseErstatningskrav: {
      ikke: {
        blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        null: "Du må beskrive kva du krev erstatning for",
      },
      maks: {
        lengde:
          "For lang skildring av erstatningskrav, maks lengde er {{messageParams.maxLength}} teikn",
      },
    },
    ikke: {
      null: "Du må svare på om du ønsker å reise eit erstatningskrav",
    },
    erstatningskravSvarType: {
      ikke: {
        null: "Du må svare på om du ønsker å reise eit erstatningskrav",
      },
    },
    fullmakt: {
      ikke: {
        null: "Du må laste opp ei fullmakt for å kunne reise erstatningskrav",
      },
    },
  },
  hendelsessted: {
    utenlandskAdresse: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
      landkodeAlpha3: {
        ikke: {
          null: "Du må oppgi eit land",
          blank: "Du må oppgi eit land",
        },
        maks: {
          lengde:
            "For lang landkode, maks lengd er {{messageParams.maxLength}} teikn",
        },
        landKode: "Ikkje gyldig land",
      },
      adresselinje: {
        ikke: {
          blank: "Teksten kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang adresselinje, maks lengd er {{messageParams.maxLength}} teikn",
        },
      },
      postnummer: {
        ikke: {
          blank: "Postnummeret kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For langt postnummer, maks lengd er {{messageParams.maxLength}} teikn",
        },
      },
      poststed: {
        ikke: {
          blank: "Poststaden kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang poststad, maks lengd er {{messageParams.maxLength}} teikn",
        },
      },
    },
    ikkeFysiskSted: {
      ikke: {
        null: "Du må beskrive kor det hende",
      },
      beskrivelse: {
        ikke: {
          null: "Du må beskrive kor det hende",
          blank: "Teksten kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For langt nettstad, maks lengd er {{messageParams.maxLength}} teikn",
        },
      },
    },
    matrikkeladresse: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
      validKartverketAdresse: "Klarte ikkje validera adressa mot kartverket",
    },
    vegadresse: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
      validKartverketAdresse: "Klarte ikkje validera adressa mot kartverket",
    },
    stedsnavn: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
      validKartverketStedsnavn:
        "Klarte ikkje validera stadnamnet mot kartverket",
      beskrivelse: {
        ikke: {
          null: "Du må beskrive gjerningsstaden",
          blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang skildring av gjerningsstaden, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
    },
    kartpunkt: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
      beskrivelse: {
        ikke: {
          null: "Du må beskrive gjerningsstaden",
          blank: "Skildringa kan ikkje bestå av berre blanke teikn",
        },
        maks: {
          lengde:
            "For lang skildring av gjerningsstaden, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
      koordinat: {
        ikke: {
          null: "Trykk på kartet for å angi kvar det skjedde",
        },
        koordinatUtenforNorge:
          "Punktet ser ut til å vera i havet eller utanfor Noregs grenser. Vel eit punkt på land i Noreg.",
        lat: {
          ikke: {
            null: "Trykk på kartet for å angi kvar det skjedde",
          },
          mellom:
            "Breiddegrada må vera mellom {{messageParams.start}} og {{messageParams.end}}",
        },
        lon: {
          ikke: {
            null: "Trykk på kartet for å angi kvar det skjedde",
          },
          mellom:
            "Lengdegrada må vera mellom {{messageParams.start}} og {{messageParams.end}}",
        },
      },
    },
    hendelsesstedValg: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
        lik: {
          verdi: "Du må oppgi ein gjerningsstad",
        },
      },
    },
    stedtype: {
      ikke: {
        null: "Du må oppgi ein gjerningsstad",
      },
    },
  },
  bekreftelseAvAnsvarSomAnmelder: {
    ikke: {
      null: "Du må stadfeste at du har forstått ansvaret ditt som meldar for å levere meldinga",
    },
    true: "Du må stadfeste at du har forstått ansvaret ditt som meldar for å levere meldinga",
  },
  anmelder: {
    navn: {
      ikke: {
        null: "Kunne ikkje hente namnet ditt frå folkeregisteret",
      },
    },
    kontaktopplysninger: {
      epost: {
        ikke: {
          null: "Du må oppgi ei e-postadresse",
        },
        gyldig: {
          epost: "Du må oppgi ei gyldig e-postadresse",
        },
        maks: {
          lengde:
            "E-postadressa er for lang, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
      telefonnummer: {
        gyldig: {
          telefonnummer: "Du må oppgi eit gyldig telefonnummer",
        },
        ikke: {
          null: "Du må oppgi eit telefonnummer",
        },
        maks: {
          lengde:
            "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} teikn",
        },
      },
    },
  },
  maaFylleUtVirksomhet: "Du må velje ei verksemd",
};
export default valideringsmeldinger;
